const autocompleteModalFilterUser = {
  site: 'Sitios',
  role: 'Perfiles'
};

export default autocompleteModalFilterUser;
